let multiLang = {
    zh: {
        required: '此项为必填',
		phoneErr: '请正确填写手机号码',
		emailErr: '邮箱格式不正确',
        more: '更多',
        digits: '必须输入整数'
    },
	en: {
        required: 'This field is required',
		phoneErr: 'Please enter valid phone numbers',
		emailErr: 'E-mail format is incorrect',
        more: "More",
        digits: 'An integer must be entered'
    }
}

export default function Language() {

    const langCode = document.documentElement.getAttribute('lang');
    let lang;
    if (langCode == 'zh-CN') {
        lang = multiLang['zh']
    } else {
        lang = multiLang[langCode]
    }
    
    return lang;
    
}